module.exports = __webpack_public_path__ + "assets/img/experience-1.ff307bbd.svg";